import { useState } from "react";
import { Button, Dialog, DialogContent, DialogTitle, IconButton, Stack } from "@mui/material";
import { ShoppingBag, X } from "lucide-react";
import { MarketplaceBrowser } from "@/components/Marketplace/MarketplaceBrowser";
import { McpConnectorList } from "@/components/Connectors/McpConnectorList";

/** Plugins & Connectors — ONE unified list. Every plugin (custom MCP connector
 *  or marketplace-installed) shows up in the same McpConnectorList with the same
 *  connected/disconnected + connect/reconnect affordances — no catalog/custom
 *  discrimination. The marketplace catalog is a *source* to add more from, so it
 *  lives behind a "Marketplace" button (same label + icon as Skills' own
 *  marketplace action) that opens it in a dialog. */
export function Plugins() {
  const [browseOpen, setBrowseOpen] = useState(false);

  return (
    <>
      <McpConnectorList
        embedded
        browseAction={
          <Button
            variant="outlined"
            startIcon={<ShoppingBag size={16} />}
            onClick={() => setBrowseOpen(true)}
          >
            Marketplace
          </Button>
        }
      />

      <Dialog open={browseOpen} onClose={() => setBrowseOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle
          sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
        >
          Marketplace
          <IconButton size="small" onClick={() => setBrowseOpen(false)} aria-label="close-browse">
            <X size={18} />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2}>
            <MarketplaceBrowser embedded />
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
}
